import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import styles from './styles.css';

class CheckboxCell extends Component {
  getCellClass() {
    const { data, updating } = this.props;
    if (!updating && data && data.userRole && data.userRole.key === 'user') {
      return styles.checkCell;
    } 
    return styles.noAccess;
  }


  renderContent() {
    const { 
      value, data, updating, 
      currentUserRole, currentModule, currentAccessType,
      column,
    } = this.props;
    const isUserRole = data.userRole.key === 'user';

    if (!isUserRole && !value) {
      return (<div className={`text-center text-muted ${styles.noAccess}`}>&mdash;</div>);
    }

    
    const colId = column ? column.colId : null;
    let name = value ? 'check-circle' : 'circle-o';
    let cls = value ? 'text-active' : 'text-active';
    let spin = false;

    if (updating && data && data.userRole.key ===  currentUserRole && 
      data.module.key === currentModule && colId === currentAccessType) {
      name = 'spinner';
      cls = 'text-muted';
      spin = true;
    }
    if (!isUserRole) {
      cls = 'text-muted';
    }

    const mainCls = this.getCellClass();
    return (
      <div style={{ fontSize: '1.5em' }} className={`text-center ${mainCls}`}><Fa className={cls} name={name} /></div>
    );
  }
  render() {
    const isGrouped = this.props.node && this.props.node.group;
    if (!isGrouped) {
      return this.renderContent();
    }
    return null;
  }
}

CheckboxCell.propTypes = {
  value: PropTypes.bool,
  data: PropTypes.shape({
    id: PropTypes.string,
    userRole: PropTypes.shape({
      key: PropTypes.string.isRequired,
    }).isRequired,
    module: PropTypes.shape({
      key: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  updating: PropTypes.bool,
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
  currentUserRole: PropTypes.string,
  currentModule: PropTypes.string,
  currentAccessType: PropTypes.string,
};
CheckboxCell.defaultProps = {
  node: null,
  updating: false,
  currentUserRole: null,
  currentModule: null,
  currentAccessType: null,
};

export default CheckboxCell;
